import Vue from 'vue'

/*
* AG Grid Methods here
*/
export default Vue.extend({
  methods: {
    intlNumberFormatter (number, locale, options) {
      if (typeof number === 'string') number = parseFloat(number)
      if (typeof number !== 'number' && !isNaN(Number(number))) return null
      const hideDecimals = (this.displayOptions || {}).hideDecimals || false
      const useParentheses = (this.displayOptions || {}).showNegativesInParenthesesInWorkSheet || false

      if (!locale) locale = 'en-us'

      if (!options) {
        options = {
          style: 'decimal',
          useGrouping: true,
          minimumFractionDigits: hideDecimals ? 0 : 2,
          maximumFractionDigits: hideDecimals ? 0 : 2
        }
      }

      let result = new Intl.NumberFormat(locale, options).format(number)

      // -0 should be just 0
      if (result === '-0' || result === '-0.00') {
        result = new Intl.NumberFormat(locale, options).format(0)
      }

      // currencySign option is not working on many browsers so manually handle
      if (useParentheses && result.slice(0, 1) === '-') {
        result = '(' + result.slice(1) + ')'
      }

      return result
    },

    accountsData () {
      return {
        values: this.allCodes && this.allCodes.accounts ? this.allCodes.accounts.filter(account => account.postable).map(d => d.code + ' - ' + d.name) : [],
        searchType: 'match',
        allowTyping: true,
        filterList: true,
        highlightMatch: true,
        valueListMaxHeight: 220,
        valueListMaxwidth: 120
      }
    },

    seriesData () {
      return {
        values: this.allCodes && this.allCodes.series ? this.allCodes.series.filter(s => s.active).map(d => d.code) : [],
        searchType: 'match',
        allowTyping: true,
        filterList: true,
        highlightMatch: true,
        valueListMaxHeight: 220,
        valueListMaxwidth: 120
      }
    },

    locationsData () {
      return {
        values: this.allCodes && this.allCodes.locations ? this.allCodes.locations.filter(s => s.active).map(d => d.code) : [],
        searchType: 'match',
        allowTyping: true,
        filterList: true,
        highlightMatch: true,
        valueListMaxHeight: 220,
        valueListMaxwidth: 120
      }
    },

    setsData () {
      return {
        values: this.allCodes && this.allCodes.sets ? this.allCodes.sets.filter(s => s.active).map(d => d.code) : [],
        searchType: 'match',
        allowTyping: true,
        filterList: true,
        highlightMatch: true,
        valueListMaxHeight: 220,
        valueListMaxwidth: 120
      }
    },

    freefieldsData () {
      return {
        values: this.allCodes && this.allCodes.freefield1 ? this.allCodes.freefield1.filter(s => s.active).map(d => d.code) : [],
        searchType: 'match',
        allowTyping: true,
        filterList: true,
        highlightMatch: true,
        valueListMaxHeight: 220,
        valueListMaxwidth: 120
      }
    },

    taxcodesData () {
      return {
        values: this.allCodes && this.allCodes.taxcodes ? this.allCodes.taxcodes.filter(s => s.active).map(d => d.code) : [],
        searchType: 'match',
        allowTyping: true,
        filterList: true,
        highlightMatch: true,
        valueListMaxHeight: 220,
        valueListMaxwidth: 120
      }
    },
    getStableRowKey (data) {
      return data.groupAccount + '::' + data.code
    },

    markFieldError (rowKey, colId, hasError) {
      const key = rowKey + '::' + colId
      const idx = this.invalidCellKeys.indexOf(key)
      if (hasError) {
        if (idx === -1) this.invalidCellKeys.push(key)
      } else {
        if (idx > -1) this.invalidCellKeys.splice(idx, 1)
      }
    },

    isFieldInvalid (params) {
      if (!params.data) return false
      const key = this.getStableRowKey(params.data) + '::' + params.colDef.colId
      return this.invalidCellKeys.indexOf(key) > -1
    },
    /*
    * Check lines are editable or not
    */
    isEditable (params) {
      // No permission to edit
      if (!this.allowEdit) return false

      // Defensive: no data yet (e.g. row still loading), or a synthetic
      // group row from the SSRM local-tree datasource — never individually
      // editable, so bail out before any field access below.
      // __isGrandTotal is flat mode's pinned total row: a summary, not a line.
      if (!params.data || params.data.__isGroup || params.data.__isGrandTotal) return false

      // Payment transactions
      if (['WIRE', 'EFT', 'MC', 'CK', 'DC'].includes(params.data.trans_type)) {
        return false
      }

      // offset line
      const lineDesc = params.data.line_desc || ''   // <-- was params.data.line_desc directly
      const lineSet = params.data.set ? params.data.set : ''
      const lineSer = params.data.series ? params.data.series : ''
      const lineLoc = params.data.location ? params.data.location : ''
      let checkText = 'SLS: #' + lineSer + '-' + lineLoc + '-' + lineSet
      const matches = ['AR Offset', 'Receipt Offset', 'PETTY CASH OFFSET', 'PCARD OFFSET', 'Credit Card Offset', 'Payroll Offset', 'Payroll Clearing', 'Fringe Clearing', 'Payroll Clearing Offset', '# PAYROLL OFFSET', '# FRINGE PAYROLL OFFSET', 'PAYROLL OFFSET', 'FRINGE PAYROLL OFFSET']
      if ((matches.includes(lineDesc) && params.data.trans_type !== 'AP') ||
          lineDesc.match('PETTY CASH ADVANCE') ||
          lineDesc.match(checkText) ||
          lineDesc.match('A/P Offset') ||
          lineDesc.match('relieved')) {
        return false
      }

      if (params.data.trans_type === 'PO') {
        if (params.data.transaction_status === 'POSTED') {
          if (params.data.line_type !== 'OPEN') {
            return false
          }
        } else {
          // Allow edits for set, location and series columns for CLOSED POs
          if (params.data.transaction_status === 'CLOSED') {
            if (params.colDef && params.colDef.colId && !['set', 'location', 'series'].includes(params.colDef.colId)) {
              return false
            }
          }
        }
      }
      return true
    },

    customSum (params) {
      let sum = 0
      params.values.forEach((value) => {
        let number = parseFloat(String(value || 0).replace(/,/g, ''))
        if (number && !isNaN(number)) sum += number
      })
      if (isNaN(sum) || sum === 0) {
        return ''
      } else {
        return sum.toFixed(2)
      }
    },

    customList (values) {
      let list = []
      values.forEach((value) => {
        if (value && list.indexOf(value) === -1) list.push(value)
      })
      if (list.length > 0) {
        return list.join(',')
      } else {
        return ''
      }
    },

    customSumSelected (params) {
      let sum = 0
      if (params.values && params.rowNode.allChildrenCount) {
        params.rowNode.allLeafChildren.filter((node) => {
          if (node.selected && node.data.attributes) {
            let number = parseFloat(String(node.data.attributes.amount_decimal || 0).replace(/,/g, ''))
            if (number && !isNaN(number)) sum += number
          }
        })
      }
      return sum.toFixed(2)
    },

    /*
     * Need this to make sure we get a valid link
    */
    buildTransLink (data) {
      let type
      switch (data.trans_type || data.src) {
        case 'AP':
          type = 'aps'
          break

        case 'PC':
          type = 'pettycash'
          break

        case 'PO':
          type = 'pos'
          break

        case 'RT':
          type = 'rts'
          break

        case 'creditcard':
        case 'CC':
          type = 'ccs'
          break

        case 'PR':
        case 'clientpayroll':
          type = 'prs'
          break

        default:
          type = 'jes'
      }
      return '<a style="color:#007bff" target="_blank" href="/' + type + '/' + data.transaction_id + '">View</a>'
    }
  }
})



// WEBPACK FOOTER //
// ./src/Mixins/SigmaClientNew/GeneralLedgerWorksheet/ColumnMethods.js